// Tiny in-memory + sessionStorage stash for live analysis results that the
// ResultScreen looks up by slug. Mocks are still served from `src/data`;
// this lets `/result/<slug>` work for freshly-analysed documents too.

import type { AnalysisResult } from '../lib/types';

const STORAGE_KEY = 'tia.lastResult';

export function stashResult(result: AnalysisResult) {
  try {
    sessionStorage.setItem(STORAGE_KEY + ':' + result.slug, JSON.stringify(result));
    sessionStorage.setItem(STORAGE_KEY + ':last', result.slug);
  } catch {
    /* sessionStorage might be full or disabled — non-fatal */
  }
}

export function readStashedResult(slug: string): AnalysisResult | undefined {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY + ':' + slug);
    if (!raw) return undefined;
    return JSON.parse(raw) as AnalysisResult;
  } catch {
    return undefined;
  }
}
